export default {
  content: {
    id: 'product_jp_product_condition_body_carousel_grade_b_content',
    defaultMessage:
      'There are minor scratches that are only visible from a distance of 50cm.',
  },
  contentNew: {
    id: 'product_jp_product_condition_body_carousel_grade_b_content_new',
    defaultMessage:
      'Scratches and dents are slightly visible at desk usage distance (approximately 50cm).',
  },
  pill1: {
    id: 'product_jp_product_condition_body_carousel_grade_b_pill_1',
    defaultMessage: 'Verified parts',
  },
  pill2: {
    id: 'product_jp_product_condition_body_carousel_grade_b_pill_2',
    defaultMessage: '80~100% battery capacity guarantee',
  },
  pill2New: {
    id: 'product_jp_product_condition_body_carousel_grade_b_pill_2_new',
    defaultMessage: 'Over 80% guaranteed',
  },
  grade: {
    id: 'product_jp_grade_11',
    defaultMessage: 'B grade (Good)',
  },
}
